import api from './api.js';

class SystemConfig {
    constructor(){
        // SystemConfig endpoints use proper case in routes
    }

    getMessage(){
        return api.get(`SystemConfig/SystemAnnouncement`, { isDataSourceRequested: true });
    }

    getMessageAdmin(){
        return api.get(`SystemConfig/SystemAnnouncementAdmin`);
    }

    getDailyMessage(){
        return api.get('daily-message');
    }

    putMessage(messageObj){
        return api.put(`SystemConfig/SystemAnnouncement`, messageObj);
    }
}

export default new SystemConfig;